/* storybook-check-ignore */
import NextLink from 'next/link';

import { Link, LinkProps } from '@opendoor/bricks/core';

export type HeaderNavigationItemProps = LinkProps &
  Required<Pick<LinkProps, 'href'>> & {
    isExternalLink?: boolean;
  };

export const HeaderNavigationItem = ({
  href,
  isExternalLink,
  ...restOfProps
}: HeaderNavigationItemProps) => {
  const linkElement = (
    <Link
      _active={{
        backgroundColor: 'neutrals40',
      }}
      _hover={{
        backgroundColor: 'neutrals20',
      }}
      alignItems="center"
      border={0}
      // @ts-expect-error - This is a known deviation from the design system.
      borderRadius={12}
      color="neutrals100"
      display="flex"
      fontSize="s1"
      fontWeight="medium"
      gap={2}
      height={40}
      href={href}
      lineHeight="s1"
      px={4}
      textDecoration="none"
      variant="inline-secondary"
      {...restOfProps}
    />
  );

  if (isExternalLink) {
    return linkElement;
  }

  return (
    <NextLink href={href} passHref>
      {linkElement}
    </NextLink>
  );
};
